/**
 * Write-only the password as cookie
 */
import React, { useEffect, useState } from 'react';
import { setSessionPassword } from '@mkitio/gatsby-theme-password-protect/src/utils/utils';
import { StaticImage } from 'gatsby-plugin-image';

const PasswordProtect = () => {
  const [password, setPassword] = useState('');
  const [isInBrowser, setIsInBrowser] = useState(false);

  const onSubmit = event => {
    event.preventDefault();
    setSessionPassword(password);
    window.location.reload(); // eslint-disable-line
  };

  useEffect(() => (
    setIsInBrowser(true)
  ), [])

  if(!isInBrowser){
    return null;
  }

  return (
    <div style={{height: '100%'}}>
      <div style={{height: '100%'}}>
        <div className="password-wrapper">
          <div className="password-container">
            <div className="password-form">

              <h2>This website is password protected.</h2>
              <p>Please enter the password to access this page.</p>

              <form onSubmit={onSubmit}>
                <input
                  autoFocus
                  name="password"
                  type="password"
                  placeholder="Password here"
                  value={password}
                  onChange={event => setPassword(event.target.value)}
                />

                <button
                  className="button red"
                  type="submit"
                >
                  Go
                </button>
              </form>
            </div>
            <div>
              <StaticImage
                src="../../../images/rocket.svg"
                formats={["AUTO", "WEBP", "AVIF"]}
                placeholder="blurred"
                alt="A rocket and flowing into space"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordProtect;
